import {app} from '../../../bootstrap/core';
import {faqComponent} from './faq.component';
import {FaqService} from './faq.service';
import {faqUrls} from './faq.constants';
import '../modals/faq.tpl.html';

app.component('faq', faqComponent);
app.service('faqService', FaqService);
app.constant('faqUrls', faqUrls);
app.value('freshdeskApiConfig', {
  apiHost: 'https://finorun.freshdesk.com/api/v2',
  apiKey: 'kB7TuW8dubC7WVrinQC',
});



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.js